/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type UseRemainingRouteVisibilitySubscriptionVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type UseRemainingRouteVisibilitySubscription = {
  __typename?: 'Subscription'
  fccVehicleTelemetry: {
    __typename?: 'FccVehicleTelemetry'
    sdsMission: Types.FccSdsMission | null
  }
}

export const UseRemainingRouteVisibilityDocument = gql`
    subscription useRemainingRouteVisibility($vehicleId: ID!) {
  fccVehicleTelemetry(vehicleId: $vehicleId) {
    sdsMission
  }
}
    `

/**
 * __useUseRemainingRouteVisibilitySubscription__
 *
 * To run a query within a React component, call `useUseRemainingRouteVisibilitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useUseRemainingRouteVisibilitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseRemainingRouteVisibilitySubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useUseRemainingRouteVisibilitySubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UseRemainingRouteVisibilitySubscription,
    UseRemainingRouteVisibilitySubscriptionVariables
  > &
    (
      | {
          variables: UseRemainingRouteVisibilitySubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    UseRemainingRouteVisibilitySubscription,
    UseRemainingRouteVisibilitySubscriptionVariables
  >(UseRemainingRouteVisibilityDocument, options)
}
export type UseRemainingRouteVisibilitySubscriptionHookResult = ReturnType<
  typeof useUseRemainingRouteVisibilitySubscription
>
export type UseRemainingRouteVisibilitySubscriptionResult =
  Apollo.SubscriptionResult<UseRemainingRouteVisibilitySubscription>
